import {
	COOKIE_AGE_VERIFIED,
	COOKIE_CREATE_ACCOUNT,
	COOKIE_VERIFY_ACCOUNT,
} from '~/utils/constants'

export const actions = {
	removeCookiesSignup() {
		this.$cookies.remove(COOKIE_CREATE_ACCOUNT, { path: '/' })
		this.$cookies.remove(COOKIE_VERIFY_ACCOUNT, { path: '/' })
		this.$cookies.remove(COOKIE_AGE_VERIFIED, { path: '/' })
	},
}
